import '../../css/App.css';
import Game3072 from "../child/Game3072.tsx";
import "../../css/Cell.css";
import InstructionsModal from "../child/InstructionsModal.tsx";
import { useCallback, useEffect, useRef, useState } from "react";
import {useAutoAnimate} from "@formkit/auto-animate/react";

const SIZE = 4;
export default function App() {
    const [showModal, setShowModal] = useState(false); // 封面帮助默认隐藏，点击帮助按钮才显示
    const [closing, setClosing] = useState(false);

    const onClose = () => {
        setClosing(true);
        setTimeout(() => {
            setShowModal(false);
            setClosing(false);
        }, 1000);
    };

  const [animationParent] = useAutoAnimate()
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  // ref 回调必须稳定（内联箭头会随渲染变化 → React 反复调用 → useAutoAnimate 无限循环 #185）
  const setWrapperRef = useCallback((el: HTMLDivElement | null) => {
    wrapperRef.current = el;
    animationParent(el);
  }, [animationParent]);

  // 视口自适应：窄窗口/浏览器高缩放下按比例缩小整个游戏容器（.game-container），
  // 保证棋盘完整可见（html 为 overflow:hidden 且 flex 居中，不再被裁切）。
  // 只缩放容器（transform 不影响布局），可用宽度按 wrapper 的左右外边距扣除。
  const fitViewport = useCallback(() => {
    const wrapper = wrapperRef.current;
    const gc = wrapper && wrapper.querySelector<HTMLElement>('.game-container');
    if (!wrapper || !gc) return;
    const cs = getComputedStyle(wrapper);
    const marginX = (parseFloat(cs.marginLeft) || 0) + (parseFloat(cs.marginRight) || 0);
    const vw = document.documentElement.clientWidth;
    const vh = document.documentElement.clientHeight;
    const availW = Math.max(vw - marginX - 12, 1);
    const availH = Math.max(vh - 12, 1);
    const natW = Math.max(gc.scrollWidth, 1);
    const natH = Math.max(gc.scrollHeight, 1);
    const scale = Math.min(1, availW / natW, availH / natH);
    gc.style.transformOrigin = 'center top';
    gc.style.transform = scale < 1 ? 'scale(' + scale + ')' : '';
  }, []);

  useEffect(() => {
    fitViewport();
    window.addEventListener('resize', fitViewport);
    window.addEventListener('orientationchange', fitViewport);
    // 首帧渲染/字体加载完成后再次校准（offset/scroll 尺寸此时才稳定）
    const t = setTimeout(fitViewport, 250);
    return () => {
      window.removeEventListener('resize', fitViewport);
      window.removeEventListener('orientationchange', fitViewport);
      clearTimeout(t);
    };
  }, [fitViewport]);

    return (
        <div ref={setWrapperRef} className={`${closing ? 'closing' : ''} mx-24 max-h-screen`}>
            {showModal && <InstructionsModal onClose={onClose}  closing={closing}/>}
            <div className={`game-container ${showModal ? 'filter blur-md' : ''}`}>
                <Game3072 size={SIZE} setShowModal={setShowModal}/>
            </div>
        </div>
    );
}

